import * as React from "react";
const SvgZurck = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Zurück">
    <path
      fill="currentColor"
      d="M160.77 209.45 84.62 133.3a7.5 7.5 0 0 1 0-10.61l76.15-76.15a7.502 7.502 0 1 1 10.61 10.61l-70.84 70.84 70.84 70.84a7.502 7.502 0 1 1-10.61 10.61Z"
    />
  </svg>
);
export default SvgZurck;
